import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished/lib/index';

const Wrapper = styled.input`
  text-transform: none;
  text-shadow: none;
  font-weight: bold;
  line-height: 1em;
  font-style: normal;
  font-size: ${rem(14)};
  text-decoration: none;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: ${rem(20)};
`;

export const RadioButton = ({ checked, onClick, value, name, label, id }) => {
  return (
    <div>
      <Wrapper
        type="radio"
        checked={checked}
        onClick={onClick}
        value={value + id}
        name={name}
      />
      {label}
    </div>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.number,
  name: PropTypes.string,
  id: PropTypes.number,
  label: PropTypes.string,
};
RadioButton.defaultProps = {
  checked: false,
  onClick: () => {},
  value: 0,
  name: '',
  id: 0,
  label: '',
};

export default withTheme(RadioButton);



// WEBPACK FOOTER //
// ./src/components/RadioButton/index.js